// extracted by mini-css-extract-plugin
export default {"mCard":"vE-z","image":"wE-z","imageNoBackground":"xE-z","fullWidth":"yE-z"};